var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB4Program(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 34h-4v5h-9v-5h-7v5h-9v-5h-3a4 4 0 00-4 4v30a4 4 0 004 4h32a4 4 0 004-4V38a4 4 0 00-4-4zm0 34H38V43h32v25zm-4-4h-6v-3h6v3zm0-7h-6v-3h6v3zm0-7h-6v-3h6v3zm-3-14h-3v-6h3v6zm-6 28h-6v-3h6v3zm0-7h-6v-3h6v3zm0-7h-6v-3h6v3zm-30.5-1.23a20.16 20.16 0 003.5-.32v4.07A24.5 24.5 0 1150.78 25h-4.07A20.49 20.49 0 1026.5 48.77zM48 64h-6v-3h6v3zm0-7h-6v-3h6v3zm0-7h-6v-3h6v3zm-3.46-20H47v6h-3v-6h.54zM25 13.17h4V31H12.11v-4H25V13.17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B4_Program.02142418.svg";
export { SvgB4Program as ReactComponent };